import { render, staticRenderFns } from "./BeefTagsList.vue?vue&type=template&id=00011624&scoped=true"
import script from "./BeefTagsList.vue?vue&type=script&lang=js"
export * from "./BeefTagsList.vue?vue&type=script&lang=js"
import style0 from "./BeefTagsList.vue?vue&type=style&index=0&id=00011624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00011624",
  null
  
)

export default component.exports